module.exports = __webpack_public_path__ + "static/media/kann-es-einem-anderen-freude-bereiten.8d8eea64.png";